import { AuftraggeberHttpServiceProvider } from '@/auftraggeber/api/AuftraggeberHttpServiceProvider';
import type { IHttpClient } from '@/shared/api/clients/HttpClient';
import { HttpAxiosClient } from '@/shared/api/clients/HttpAxiosClient';

let httpClientInstance: IHttpClient;
let httpServiceProvider: AuftraggeberHttpServiceProvider;

export const useAuftraggeberApi = (): AuftraggeberHttpServiceProvider => {
  if (!httpClientInstance) {
    httpClientInstance = new HttpAxiosClient();
    httpServiceProvider = new AuftraggeberHttpServiceProvider(httpClientInstance);
  }

  return httpServiceProvider;
};
